import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './MotorPromoModal.module.scss';
import { shouldShowMotorPromo } from './motorPromoVisibility';

const STORAGE_KEY = 'motorPromoDismissedAt';
const SHOW_DELAY_MS = 1000;
const LOGO_BASE = '/tvp/komunikacyjne';

const INSURERS = [
  { name: 'PZU', src: `${LOGO_BASE}/pzu.svg`, scale: 1.12 },
  { name: 'Allianz', src: `${LOGO_BASE}/allianz.svg` },
  { name: 'Generali', src: `${LOGO_BASE}/generali.svg` },
  { name: 'Ergo Hestia', src: `${LOGO_BASE}/ergo-hestia.svg` },
  { name: 'InterRisk', src: `${LOGO_BASE}/interrisk.svg`, scale: 1.45 },
  { name: 'Uniqa', src: `${LOGO_BASE}/uniqa.svg`, scale: 1.1 }
];

const readDismissedAt = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const saveDismissedAt = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch (error) {
    // localStorage zablokowany — popup wróci przy kolejnym wejściu
  }
};

const MotorPromoModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!shouldShowMotorPromo(new Date(), readDismissedAt())) {
      return undefined;
    }

    const timer = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) {
    return null;
  }

  const dismiss = () => {
    saveDismissedAt();
    setVisible(false);
  };

  return (
    <div className={classes.overlay} onClick={dismiss} role="presentation">
      <div
        className={classes.card}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Promocja: Ubezpieczenie Twojego Auta — Pakiety Dealerskie">
        <button
          type="button"
          className={classes.closeButton}
          onClick={dismiss}
          aria-label="Zamknij">
          ×
        </button>
        <span className={classes.eyebrow}>OC · AC · Assistance · NNW</span>
        <h2 className={classes.headline}>
          Ubezpieczenie Twojego Auta —{' '}
          <span className={classes.highlight}>Pakiety Dealerskie</span>
        </h2>
        <p className={classes.subline}>
          Wynegocjowane pakiety 6&nbsp;towarzystw dla aut osobowych,
          dostawczych do&nbsp;3,5&nbsp;t i&nbsp;kamperów — także
          w&nbsp;leasingu.
        </p>
        <ul className={classes.logos} aria-label="Towarzystwa w ofercie">
          {INSURERS.map((i) => (
            <li key={i.name} className={classes.logoItem}>
              <img
                src={i.src}
                alt={i.name}
                className={classes.logo}
                style={i.scale ? { '--logo-scale': i.scale } : undefined}
              />
            </li>
          ))}
        </ul>
        <Link
          className={classes.ctaButton}
          to="/komunikacyjne/opis/#formularz"
          onClick={dismiss}>
          Zapytaj o ofertę
        </Link>
        <Link
          className={classes.details}
          to="/komunikacyjne/opis/"
          onClick={dismiss}>
          Poznaj pakiety
        </Link>
      </div>
    </div>
  );
};

export default MotorPromoModal;
